import { render, staticRenderFns } from "./pdmIndex.vue?vue&type=template&id=075aa84e&scoped=true"
import script from "./pdmIndex.vue?vue&type=script&lang=js"
export * from "./pdmIndex.vue?vue&type=script&lang=js"
import style0 from "./pdmIndex.vue?vue&type=style&index=0&id=075aa84e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075aa84e",
  null
  
)

export default component.exports